"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-old-cost" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(_ctx.getClasses())
        }, (0, vue_1.toDisplayString)(_ctx.amount === null ? 0 : _ctx.amount), 3),
        (_ctx.displayTwoCosts())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", { class: "card-cost-transition" }, null, -1)),
                (0, vue_1.createElementVNode)("div", _hoisted_1, (0, vue_1.toDisplayString)(_ctx.newCost), 1)
            ], 64))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
